module.exports = __webpack_public_path__ + "img/PXL_20230526_091024340.9ca31a77.jpg";